module.exports = __webpack_public_path__ + "img/ep-I-dosis.26673f33.jpg";